import { render, staticRenderFns } from "./ModalInviteMembers.vue?vue&type=template&id=1bbf13da&"
import script from "./ModalInviteMembers.vue?vue&type=script&lang=js&"
export * from "./ModalInviteMembers.vue?vue&type=script&lang=js&"
import style0 from "./ModalInviteMembers.vue?vue&type=style&index=0&id=1bbf13da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports